(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const toggle = document.querySelector('[data-header-search-toggle]');
    const panel = document.querySelector('[data-header-search-panel]');
    const input = document.querySelector('[data-header-search-input]');
    const suggest = document.querySelector('[data-header-search-suggest]');
    const i18n = document.querySelector('[data-header-search-i18n]');
    if (!toggle || !panel || !input || !suggest) return;

    let activeIndex = -1;
    let timer = null;
    let abortController = null;

    const escapeHtml = (value = '') =>
      String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const hideSuggest = () => {
      suggest.hidden = true;
      suggest.innerHTML = '';
      activeIndex = -1;
    };

    const showEmpty = (message) => {
      suggest.innerHTML = `<div class="gyc-header__search-suggest-empty">${escapeHtml(message)}</div>`;
      suggest.hidden = false;
      activeIndex = -1;
    };

    const items = () => Array.from(suggest.querySelectorAll('.gyc-header__search-suggest-item'));

    const setActive = (index) => {
      const links = items();
      if (!links.length) {
        activeIndex = -1;
        return;
      }

      activeIndex = Math.max(0, Math.min(index, links.length - 1));
      links.forEach((link, i) => link.classList.toggle('is-active', i === activeIndex));
    };

    const fetchSuggestions = async (query) => {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product,collection,page,query',
        'resources[options][fields]': 'title,product_type,variants.title,tag,vendor',
        'resources[options][unavailable_products]': 'last',
        'resources[limit]': '8'
      });

      const response = await fetch(`/search/suggest.json?${params.toString()}`, {
        headers: { Accept: 'application/json' },
        signal: abortController.signal
      });
      if (!response.ok) throw new Error('Suggest request failed');

      const data = await response.json();
      const results = data?.resources?.results || {};

      return [
        ...(results.queries || []).map((item) => ({ title: item.text, url: `/search?q=${encodeURIComponent(item.text)}&type=product&options[prefix]=last`, type: i18n?.dataset.typeQuery || 'Search' })),
        ...(results.products || []).map((item) => ({ title: item.title, url: item.url, type: i18n?.dataset.typeProduct || 'Product' })),
        ...(results.collections || []).map((item) => ({ title: item.title, url: item.url, type: i18n?.dataset.typeCollection || 'Collection' })),
        ...(results.pages || []).map((item) => ({ title: item.title, url: item.url, type: i18n?.dataset.typePage || 'Page' }))
      ].slice(0, 8);
    };

    const renderSuggestions = (results) => {
      if (!results.length) {
        showEmpty(i18n?.dataset.suggestEmpty || 'No suggestions yet.');
        return;
      }

      suggest.innerHTML = results
        .map(
          (item) => `
            <a class="gyc-header__search-suggest-item" href="${escapeHtml(item.url)}">
              <span>${escapeHtml(item.title)}</span>
              <span class="gyc-header__search-suggest-type">${escapeHtml(item.type)}</span>
            </a>
          `
        )
        .join('');
      suggest.hidden = false;
      activeIndex = -1;
    };

    const setOpen = (open) => {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        window.setTimeout(() => {
          input.focus();
        }, 0);
      } else {
        hideSuggest();
      }
    };

    toggle.addEventListener('click', () => {
      setOpen(panel.hidden);
    });

    input.addEventListener('input', () => {
      const query = input.value.trim();
      window.clearTimeout(timer);

      if (query.length < 2) {
        hideSuggest();
        return;
      }

      timer = window.setTimeout(async () => {
        try {
          const results = await fetchSuggestions(query);
          renderSuggestions(results);
        } catch (error) {
          if (error.name === 'AbortError') return;
          showEmpty(i18n?.dataset.suggestError || 'Could not load suggestions.');
        }
      }, 180);
    });

    input.addEventListener('keydown', (event) => {
      const links = items();
      if (!links.length || suggest.hidden) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(activeIndex <= 0 ? links.length - 1 : activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        links[activeIndex].click();
      } else if (event.key === 'Escape') {
        hideSuggest();
      }
    });

    document.addEventListener('click', (event) => {
      if (panel.hidden) return;
      if (panel.contains(event.target) || toggle.contains(event.target)) return;
      setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  })();

  (() => {
    const toggles = Array.from(document.querySelectorAll('[data-account-menu-toggle]'));
    if (!toggles.length) return;

    const pairs = toggles
      .map((toggle) => {
        const id = toggle.getAttribute('aria-controls');
        if (!id) return null;
        const menu = document.getElementById(id);
        if (!menu) return null;
        return { toggle, menu };
      })
      .filter(Boolean);
    if (!pairs.length) return;

    const setOpen = (pair, open) => {
      pair.menu.hidden = !open;
      pair.toggle.setAttribute('aria-expanded', String(open));
    };

    const closeAll = () => {
      pairs.forEach((pair) => setOpen(pair, false));
    };

    pairs.forEach((pair) => {
      pair.toggle.addEventListener('click', () => {
        const shouldOpen = pair.menu.hidden;
        closeAll();
        setOpen(pair, shouldOpen);
      });
    });

    document.addEventListener('click', (event) => {
      const clickedInside = pairs.some(
        (pair) => pair.menu.contains(event.target) || pair.toggle.contains(event.target)
      );
      if (!clickedInside) closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  })();

  (() => {
    const toggle = document.querySelector('[data-mobile-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    const closeButtons = document.querySelectorAll('[data-mobile-menu-close]');
    if (!toggle || !menu) return;

    const CLOSE_MS = 280;
    let closeTimer = null;
    let rafId = null;

    const clearCloseTimer = () => {
      if (!closeTimer) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    const clearRaf = () => {
      if (!rafId) return;
      window.cancelAnimationFrame(rafId);
      rafId = null;
    };

    const openMenu = () => {
      clearCloseTimer();
      clearRaf();
      menu.hidden = false;
      menu.classList.remove('is-closing');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      // Wait one frame so initial styles are committed, then animate in.
      rafId = window.requestAnimationFrame(() => {
        menu.classList.add('is-open');
      });
    };

    const closeMenu = () => {
      clearCloseTimer();
      clearRaf();
      menu.classList.remove('is-open');
      menu.classList.add('is-closing');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      let closed = false;
      const finalizeClose = () => {
        if (closed) return;
        closed = true;
        clearCloseTimer();
        menu.removeEventListener('transitionend', onTransitionEnd);
        menu.classList.remove('is-closing');
        menu.hidden = true;
      };
      const onTransitionEnd = (event) => {
        if (event.target !== menu.querySelector('.gyc-mobile-menu__panel')) return;
        finalizeClose();
      };
      menu.addEventListener('transitionend', onTransitionEnd);
      closeTimer = window.setTimeout(finalizeClose, CLOSE_MS);
    };

    toggle.addEventListener('click', () => {
      if (menu.hidden || menu.classList.contains('is-closing')) {
        openMenu();
      } else {
        closeMenu();
      }
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closeMenu());
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) closeMenu();
    });
  })();

  (() => {
    // Desktop Nav Dropdown Click & Hover Management
    const desktopDropdowns = document.querySelectorAll('[data-nav-dropdown]');
    if (desktopDropdowns.length) {
      const closeAllDesktopDropdowns = () => {
        desktopDropdowns.forEach((item) => {
          item.classList.remove('is-open');
          const trigger = item.querySelector('[data-nav-dropdown-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.blur();
          }
        });
      };

      desktopDropdowns.forEach((item) => {
        const trigger = item.querySelector('[data-nav-dropdown-trigger]');
        if (!trigger) return;

        // Toggle on click without navigating
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const wasOpen = item.classList.contains('is-open');

          closeAllDesktopDropdowns();

          if (!wasOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });

        // When mouse enters THIS dropdown item, close any OTHER dropdown that was open
        item.addEventListener('mouseenter', () => {
          desktopDropdowns.forEach((other) => {
            if (other !== item) {
              other.classList.remove('is-open');
              const otherTrig = other.querySelector('[data-nav-dropdown-trigger]');
              if (otherTrig) {
                otherTrig.setAttribute('aria-expanded', 'false');
                otherTrig.blur();
              }
            }
          });
        });

        // When mouse leaves this dropdown item, remove the locked is-open state
        item.addEventListener('mouseleave', () => {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.blur();
        });

        // Keyboard focus management: close when focus leaves the dropdown completely
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      });

      // Hovering over any other top-level nav link (e.g. Home) closes all dropdowns
      const topNavLinks = document.querySelectorAll('.gyc-header__nav > a');
      topNavLinks.forEach((link) => {
        link.addEventListener('mouseenter', closeAllDesktopDropdowns);
      });

      // Hovering outside the nav (logo, actions) closes open dropdowns
      document.querySelectorAll('.gyc-header__logo, .gyc-header__actions').forEach((el) => {
        el.addEventListener('mouseenter', closeAllDesktopDropdowns);
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-nav-dropdown]')) {
          closeAllDesktopDropdowns();
        }
      });

      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeAllDesktopDropdowns();
        }
      });
    }

    // Mobile Nav Accordions
    document.querySelectorAll('[data-mobile-accordion]').forEach((acc) => {
      const toggle = acc.querySelector('[data-mobile-toggle]');
      const content = acc.querySelector('.gyc-mobile-nav__content');
      if (!toggle || !content) return;
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = acc.classList.contains('is-open');
        if (isOpen) {
          acc.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          content.hidden = true;
        } else {
          acc.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          content.hidden = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-world"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroScrollBtn = document.getElementById('gycHeroScrollDown');
    if (heroScrollBtn) {
      heroScrollBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const heroSection = document.querySelector('.gyc-home-hero');
        if (heroSection) {
          const nextElem = heroSection.nextElementSibling;
          if (nextElem) {
            nextElem.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            window.scrollBy({ top: window.innerHeight * 0.85, behavior: 'smooth' });
          }
        }
      });
    }

    const videos = Array.from(document.querySelectorAll('[data-hero-video]'));
    if (!videos.length) return;

    const playVideo = (video) => {
      if (!video.paused) return;
      video.play().catch(() => {});
    };

    const pauseVideo = (video) => {
      if (video.paused) return;
      video.pause();
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          video.dataset.inViewport = entry.isIntersecting ? 'true' : 'false';
          if (entry.isIntersecting && !document.hidden) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach((video) => {
      video.dataset.inViewport = 'false';
      io.observe(video);
    });

    document.addEventListener('visibilitychange', () => {
      videos.forEach((video) => {
        if (document.hidden) {
          pauseVideo(video);
          return;
        }
        if (video.dataset.inViewport === 'true') playVideo(video);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const suggestRoot = document.querySelector('[data-search-suggest]');
    if (!suggestRoot) return;
    const searchPath = suggestRoot.closest('[data-search-path]')?.dataset.searchPath || '/search';
    const i18n = suggestRoot.querySelector('[data-search-suggest-i18n]');

    const input = suggestRoot.querySelector('[data-search-suggest-input]');
    const list = suggestRoot.querySelector('[data-search-suggest-list]');
    if (!input || !list) return;

    let activeIndex = -1;
    let timer = null;
    let abortController = null;

    const focusInput = () => {
      input.focus({ preventScroll: true });
      const length = input.value.length;
      input.setSelectionRange(length, length);
    };

    const escapeHtml = (value = '') =>
      String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const hide = () => {
      list.hidden = true;
      list.innerHTML = '';
      activeIndex = -1;
    };

    const showEmpty = (message) => {
      list.innerHTML = `<div class="gyc-search-suggest__empty">${escapeHtml(message)}</div>`;
      list.hidden = false;
      activeIndex = -1;
    };

    const items = () => Array.from(list.querySelectorAll('.gyc-search-suggest__item'));

    const setActive = (index) => {
      const suggestions = items();
      if (!suggestions.length) {
        activeIndex = -1;
        return;
      }

      activeIndex = Math.max(0, Math.min(index, suggestions.length - 1));
      suggestions.forEach((item, i) => item.classList.toggle('is-active', i === activeIndex));
    };

    const fetchSuggestions = async (query) => {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product,collection,page,query',
        'resources[options][fields]': 'title,product_type,variants.title,tag,vendor',
        'resources[options][unavailable_products]': 'last',
        'resources[limit]': '8'
      });

      const response = await fetch(`/search/suggest.json?${params.toString()}`, {
        headers: { Accept: 'application/json' },
        signal: abortController.signal
      });
      if (!response.ok) throw new Error('Suggest request failed');

      const data = await response.json();
      const results = data?.resources?.results || {};

      return [
        ...(results.queries || []).map((item) => ({ title: item.text, url: `/search?q=${encodeURIComponent(item.text)}&type=product&options[prefix]=last`, type: i18n?.dataset.typeQuery || 'Search' })),
        ...(results.products || []).map((item) => ({ title: item.title, url: item.url, type: i18n?.dataset.typeProduct || 'Product' })),
        ...(results.collections || []).map((item) => ({ title: item.title, url: item.url, type: i18n?.dataset.typeCollection || 'Collection' })),
        ...(results.pages || []).map((item) => ({ title: item.title, url: item.url, type: i18n?.dataset.typePage || 'Page' }))
      ].slice(0, 8);
    };

    const renderSuggestions = (results) => {
      if (!results.length) {
        showEmpty(i18n?.dataset.suggestEmpty || 'No suggestions yet.');
        return;
      }

      list.innerHTML = results
        .map(
          (item) => `
            <a class="gyc-search-suggest__item" href="${escapeHtml(item.url)}">
              <span>${escapeHtml(item.title)}</span>
              <span class="gyc-search-suggest__type">${escapeHtml(item.type)}</span>
            </a>
          `
        )
        .join('');
      list.hidden = false;
      activeIndex = -1;
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      window.clearTimeout(timer);

      if (query.length < 2) {
        hide();
        return;
      }

      timer = window.setTimeout(async () => {
        try {
          const results = await fetchSuggestions(query);
          renderSuggestions(results);
        } catch (error) {
          if (error.name === 'AbortError') return;
          showEmpty(i18n?.dataset.suggestError || 'Could not load suggestions.');
        }
      }, 180);
    });

    input.addEventListener('keydown', (event) => {
      const suggestions = items();
      if (!suggestions.length || list.hidden) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(activeIndex <= 0 ? suggestions.length - 1 : activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        suggestions[activeIndex].click();
      } else if (event.key === 'Escape') {
        hide();
      }
    });

    document.addEventListener('click', (event) => {
      if (!event.target || !(event.target instanceof Node)) return;
      if (!suggestRoot.contains(event.target)) {
        hide();
      }
    });

    input.addEventListener('blur', () => {
      window.setTimeout(() => {
        if (!suggestRoot.matches(':hover')) hide();
      }, 120);
    });

    const maybeFocusFromHash = () => {
      if (window.location.hash !== '#gyc-search-input') return;
      focusInput();
    };

    maybeFocusFromHash();
    window.addEventListener('hashchange', maybeFocusFromHash);

    document.addEventListener('click', (event) => {
      if (!event.target || typeof event.target.closest !== 'function') return;
      const trigger = event.target.closest('[data-header-search-trigger]');
      if (!trigger) return;

      if (window.location.pathname === searchPath) {
        event.preventDefault();
        if (window.location.hash !== '#gyc-search-input') {
          window.location.hash = 'gyc-search-input';
        }
        focusInput();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
